type SiteOriginConfig = { dev: boolean; configuredUrl?: string };

const ERROR = 'VITE_PRODUCT_SITE_URL must be an absolute HTTPS origin without credentials, path, query, or fragment';
const DEVELOPMENT_DEFAULT = 'https://app.pinpointedu.com';

export function resolveSiteOrigin({ dev, configuredUrl }: SiteOriginConfig): string {
  const candidate = (configuredUrl ?? (dev ? DEVELOPMENT_DEFAULT : '')).trim().replace(/\/+$/, '');
  let parsed: URL;
  try {
    parsed = new URL(candidate);
  } catch {
    throw new Error(ERROR);
  }
  const loopback = ['localhost', '127.0.0.1', '[::1]'].includes(parsed.hostname.toLowerCase());
  const valid = (parsed.protocol === 'https:' || (parsed.protocol === 'http:' && loopback))
    && !parsed.username
    && !parsed.password
    && parsed.pathname === '/'
    && !parsed.search
    && !parsed.hash;
  if (!valid) throw new Error(ERROR);
  return parsed.origin;
}

export function joinSiteUrl(origin: string, path: string): string {
  if (!path.startsWith('/') || path.startsWith('//')) throw new Error('cross-site path must be root-relative');
  return new URL(path, origin).href;
}

export const productSiteOrigin = resolveSiteOrigin({
  dev: import.meta.env.DEV,
  configuredUrl: import.meta.env.VITE_PRODUCT_SITE_URL,
});

export function productSiteUrl(path: string): string {
  return joinSiteUrl(productSiteOrigin, path);
}
